/* eslint-disable no-unused-vars */
import styles from './styles.module.scss'
import React, { useEffect, useState } from 'react'
import { ReactComponent as LogoImg } from '../../../assets/icons/light-logo.svg'
import { ReactComponent as MenuIcon } from '../../../assets/icons/menu-icon.svg'
import links from '../Sidebar/Links'
import { Link, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

function Navbar() {
  const { t } = useTranslation()
  const auth = useSelector((state) => state.auth)
  const { profile } = auth?.user || {}
  const isAdmin = profile?.role === 'admin'
  const [showMenu, setShowMenu] = useState(false)
  const location = useLocation()

  useEffect(() => {
    setShowMenu(false)
  }, [location])
  return (
    <nav className={styles.navbar}>
      <MenuIcon onClick={() => setShowMenu((prev) => !prev)} />
      <LogoImg />
      <div className={`${styles.mobile_menu_nav} ${showMenu ? styles.active_nav_menu : ''}`}>
        <ul className={styles.nav_list}>
          {t &&
            links(isAdmin, t)?.map((link) => {
              return (
                <li key={link.path} className={styles.links_list_li}>
                  <Link
                    to={link.path}
                    className={`${styles.link} ${styles[`${link.path}`]} ${location.pathname?.includes(link.path) ? styles.active_link : ''}`}
                  >
                    {link.icon}
                    <span className={styles.link_text}>{link.name}</span>
                  </Link>
                </li>
              )
            })}
        </ul>
      </div>
    </nav>
  )
}
export default Navbar
